export const ERRORS = {
  GET_ACCOUNT_INFO_FAILED: "getAccountInfoFailed",
  GET_ALL_BOOKS_FAILED: "getAllBooksFailed",
  GET_BOOK_FAILED: "getBookFailed",
  GET_ASSET_FAILED: "getAssetFailed",
  GET_TITLE_FAILED: "getTitleFailed",
  GET_CHAPTER_TEST_FAILED: "getChapterTestFailed",
  GET_TEST_RESULTS: "getTestResults",
  POST_TEST_RESULT_FAILED: "postTestResultFailed",
  GET_LICENSES_FAILED: "getLicensesFailed",
};
